import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { RouteTextTemplate, getRouteTextKeys } from '../models';

@Injectable({
  providedIn: 'root'
})
export class TextService {
  //Text service se encarga de devolver el mensaje que se muestra en la vista según la ruta en la que se encuentre

  private textSubject = new BehaviorSubject<RouteTextTemplate>({
    title: '',
    text: '',
    tab: ''
  });

  text$ = this.textSubject.asObservable();

  constructor(private router: Router, private titleService: Title, private route: ActivatedRoute, private translate: TranslateService) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.refreshCurrentRouteText();
      });

    this.translate.onLangChange.subscribe(() => {
      this.refreshCurrentRouteText();
    });
  }

  private refreshCurrentRouteText(): void {
    const url = this.router.url;
    const cleanUrl = url.split('?')[0]; // Elimina los parámetros
    const currentRoute: any = '/' + cleanUrl.split('/').filter(Boolean).pop();

    let params: Record<string, string | number> = {};
    if (currentRoute.includes('confirm-recovery')) {
      const token = this.route.snapshot.queryParamMap.get('token');
      const userName = token ? window.atob(token) : '';
      params = { email: userName };
    }

    const textKeys = getRouteTextKeys(currentRoute);
    this.translate.get([textKeys.titleKey, textKeys.textKey, textKeys.tabKey], params)
      .subscribe(translations => {
        const pageData: RouteTextTemplate = {
          title: translations[textKeys.titleKey],
          text: translations[textKeys.textKey],
          tab: translations[textKeys.tabKey],
        };
        this.setRouteDescription(pageData);
      });
  }

  setRouteDescription(pageData: RouteTextTemplate) {
    this.textSubject.next(pageData);
    this.titleService.setTitle(pageData.tab); // Cambia el título del navegador
  }


}
